// Generated using typescript-generator version null on 2017-09-26 15:25:27.

import {Observable} from "rxjs/Rx";
import {Injectable} from "@angular/core";


export const UPDATE_PASSWORD_ALERTE_VISIBILITY_KEY = "alerteVisibility";
export const DAYS_BEFORE_EXPIRE_KEY = "daysBeforeExpire";
export const IS_FIRST_CONNECTION_KEY = "firstConnection";
export const MIN_PASSWORD_LENGTH = 12;
export const MAX_PASSWORD_LENGTH = 20;


export class TagLightDto implements Dto {
  libelle: string;
  code: string;
}

export class AbstractLongIdObject implements LongIdObject {
  id: number;
}

export class SaveFormationDto extends AbstractLongIdObject {
  reference: string;
  titre: string;
  active: boolean;
  dateFormation: any;
  duree: number;
  lieux: string;
  programme: CreateRessourceMultimediaDto;
  plan: CreateRessourceMultimediaDto;
  tarif: number;
  order: number;
  nombrePlaces: number;
}

export class FormationDto extends AbstractLongIdObject {
  reference: string;
  titre: string;
  active: boolean;
  dateFormation: any;
  duree: number;
  lieux: string;
  programmeId: number;
  planId: number;
  tarif: number;
  order: number;
  nombrePlaces: number;
  nombrePlacesReservees: number;
  archive: boolean;
}

export class FormationSearchCriteria {
  visible: boolean;
  formationIds: number[];
}

export class CommandeFormationDto extends AbstractLongIdObject {
  dateCreation: any;
  etat: EtatCommandeEnum;
  modePaiement: ModePaiementEnum;
  commanditaire: OrganismeCommanditaireDto;
  formations: FormationDto[];
  participants: ParticipantFormationDto[];
}

export class SaveParticipantFormationDto extends AbstractLongIdObject {
  civilite: CiviliteEnum;
  nom: string;
  prenom: string;
  fonction: string;
  rppsOrAdeli: string;
  telephone: string;
  email: string;
  ogdpc: boolean;
  organismePriseEnCharge: string;
  formationIds: number[];
}

export class SaveCommandeFormationDto implements Dto {
  formationIds: number[];
  modePaiement: ModePaiementEnum;
  organismeCommanditaire: OrganismeCommanditaireDto;
  participants: SaveParticipantFormationDto[];
}

export class Response implements AutoCloseable {
  mediaType: MediaType;
  lastModified: Date;
  date: Date;
  headers: any;
  entity: any;
  status: number;
  statusInfo: StatusType;
  metadata: any;
  allowedMethods: string[];
  cookies: { [index: string]: NewCookie };
  entityTag: EntityTag;
  links: Link[];
  stringHeaders: any;
  length: number;
  language: Locale;
  location: URI;
}

export class OrganismeCommanditaireDto extends AbstractLongIdObject {
  nom: string;
  adresse: string;
  ville: string;
  codePostal: string;
  telephone: string;
  fax: string;
  email: string;
}

export class CorrespondantDetailsDto {
  code: string;
  nom: string;
  adressePrincipale: AdresseDto;
  adresseLivraison: AdresseDto;
  telephone: string;
  fax: string;
  email: string;
  numFiness: string;
  numAdeli: string;
  codeRpps: string;
  typeCarte: string;
  correspondantParent: string;
}

export class UserInformations {
  id?: string;
  login?: string;
  prenom?: string;
  nom?: string;
  telephone?: string;
  role?: UserRole;
  metadata?: { [index: string]: any };
  lang?: Locale;
  modules?: string[];
  correspondants?: Correspondant[];
  date?: any;
  expires?: any;
  origine?: string;
  url?: string;
  codeRpps?: string;
  properties?: { [index: string]: any };
  'e-mail'?: string;
  daysBeforeExpire: number | undefined | null;
  firstConnection: boolean | undefined | null;
}

export class Profil {
  id?: number;
  libelle?: string;
  champs?: string;
}

export class CreateRessourceMultimediaDto implements Dto {
  name: string;
  mimeType: string;
  size: number;
  content: string;
}

export class DocumentComplementaireDto extends AbstractLongIdObject {
  url: string;
  label: string;
}

export class ParticipantFormationDto extends AbstractLongIdObject {
  civilite: CiviliteEnum;
  nom: string;
  prenom: string;
  fonction: string;
  rppsOrAdeli: string;
  telephone: string;
  email: string;
  ogdpc: boolean;
  organismePriseEnCharge: string;
  formations: FormationDto[];
}

export interface Dto {
}

export class MediaType {
  type: string;
  subtype: string;
  parameters: { [index: string]: string };
  wildcardSubtype: boolean;
  wildcardType: boolean;
}

export interface StatusType {
  family: Family;
  statusCode: number;
  reasonPhrase: string;
}

export class Cookie {
  name: string;
  value: string;
  version: number;
  path: string;
  domain: string;
}

export class NewCookie extends Cookie {
  comment: string;
  maxAge: number;
  expiry: Date;
  secure: boolean;
  httpOnly: boolean;
}

export class EntityTag {
  value: string;
  weak: boolean;
}

export class Link {
  rels: string[];
  rel: string;
  uriBuilder: UriBuilder;
  uri: URI;
  params: { [index: string]: string };
  title: string;
  type: string;
}

export class Locale implements Cloneable, Serializable {
}

export class URI implements Comparable<URI>, Serializable {
}

export interface AutoCloseable {
}

export class AdresseDto {
  ligne1: string;
  ligne2: string;
  ligne3: string;
  codePostal: string;
  ville: string;
  pays: string;
}

export class CorrespondantDto implements Dto {
  code: string;
  nom: string;
  tags: string[];
}

export class Correspondant {
  code: string;
  nom: string;
  tags: string[];
  dateDesactivation: any;
  metadata: { [index: string]: any };
}

export interface LongIdObject {
  id: number;
}

export class UriBuilder {
}

export interface Cloneable {
}

export interface Serializable {
}

export interface Comparable<T> {
}

export abstract class HttpClient {

  abstract request(requestConfig: { method: string; url: string; queryParams?: any; data?: any; }): RestResponse<any>;
}

@Injectable()
export class IAuditWebServiceClient {

  constructor(protected httpClient: HttpClient) {
  }

  /**
   * /info
   * Response code 200 - Le log a Ã©tÃ© ajoutÃ© avec succÃ¨s
   * Response code 500 - Erreur interne lors du log d'audit
   * HTTP POST /audit/info
   * Java method: fr.cerba.digicerba.authentification.webservices.audit.IAuditWebService.info
   */
  info(queryParams?: { url?: string; message?: string; }): RestResponse<void> {
    return this.httpClient.request({method: 'POST', url: uriEncoding`audit/info`, queryParams: queryParams});
  }
}

@Injectable()
export class IFormationWebServiceClient {

  constructor(protected httpClient: HttpClient) {
  }

  /**
   * formations/computePlacesDiponibles
   * Response code 200 - Comptage des places restantes
   * HTTP POST /catalogue/formations/computePlacesDiponibles
   * Java method: fr.cerba.digicerba.catalogueformation.webservices.catalogue.IFormationWebService.computeMultiplePlaceDisponibles
   */
  computeMultiplePlaceDisponibles(arg0: number[]): RestResponse<number[]> {
    return this.httpClient.request({
      method: 'POST',
      url: uriEncoding`catalogue/formations/computePlacesDiponibles`,
      data: arg0
    });
  }

  /**
   * formation/computePlacesDiponibles/{id}
   * Response code 200 - Comptage des places restantes
   * HTTP POST /catalogue/formation/computePlacesDiponibles/{id}
   * Java method: fr.cerba.digicerba.catalogueformation.webservices.catalogue.IFormationWebService.computePlaceDisponibles
   */
  computePlaceDisponibles(id: string, arg0: number): RestResponse<number> {
    return this.httpClient.request({
      method: 'POST',
      url: uriEncoding`catalogue/formation/computePlacesDiponibles/${id}`,
      data: arg0
    });
  }

  /**
   * formation/create
   * Response code 200 - Retourne la formation crÃ©Ã©e
   * HTTP POST /catalogue/formation/create
   * Java method: fr.cerba.digicerba.catalogueformation.webservices.catalogue.IFormationWebService.createFormation
   */
  createFormation(arg0: SaveFormationDto): RestResponse<FormationDto> {
    return this.httpClient.request({method: 'POST', url: uriEncoding`catalogue/formation/create`, data: arg0});
  }

  /**
   *
   * @param id
   * @returns {RestResponse<any>}
   */
  archiveFormation(id: number): RestResponse<void> {
    return this.httpClient.request({method: 'PUT', url: uriEncoding`catalogue/formation/archive/${id}`});
  }

  /**
   * formation/delete
   * Response code 200 - Supprime la formation
   * HTTP DELETE /catalogue/formation/delete/{id}
   * Java method: fr.cerba.digicerba.catalogueformation.webservices.catalogue.IFormationWebService.deleteFormation
   */
  deleteFormation(id: number): RestResponse<void> {
    return this.httpClient.request({method: 'DELETE', url: uriEncoding`catalogue/formation/delete/${id}`});
  }

  /**
   * documentscomplementaires/findall
   * Response code 200 - Retourne la liste des documents complÃ©mentaires selon les critÃ¨res
   * HTTP GET /catalogue/documentscomplementaires/findall
   * Java method: fr.cerba.digicerba.catalogueformation.webservices.catalogue.IFormationWebService.findAllDocumentsComplementaires
   */
  findAllDocumentsComplementaires(): RestResponse<DocumentComplementaireDto[]> {
    return this.httpClient.request({method: 'GET', url: uriEncoding`catalogue/documentscomplementaires/findall`});
  }

  /**
   * formation/{id}
   * Response code 200 - Retourne la formation
   * Response code 500 - Erreur interne
   * HTTP GET /catalogue/formation/{id}
   * Java method: fr.cerba.digicerba.catalogueformation.webservices.catalogue.IFormationWebService.findFormation
   */
  findFormation(id: number): RestResponse<FormationDto> {
    return this.httpClient.request({method: 'GET', url: uriEncoding`catalogue/formation/${id}`});
  }

  /**
   * formations/search
   * Response code 200 - Retourne la liste de formations selon les critÃ¨res
   * Response code 500 - Erreur interne
   * HTTP POST /catalogue/formations/search
   * Java method: fr.cerba.digicerba.catalogueformation.webservices.catalogue.IFormationWebService.searchFormations
   */
  searchFormations(arg0: FormationSearchCriteria): RestResponse<FormationDto[]> {
    return this.httpClient.request({method: 'POST', url: uriEncoding`catalogue/formations/search`, data: arg0});
  }

  /**
   * formation/update
   * Response code 200 - Retourne la formation modifiÃ©e
   * HTTP PUT /catalogue/formation/update/{id}
   * Java method: fr.cerba.digicerba.catalogueformation.webservices.catalogue.IFormationWebService.updateFormation
   */
  updateFormation(id: number, arg1: SaveFormationDto): RestResponse<FormationDto> {
    return this.httpClient.request({method: 'PUT', url: uriEncoding`catalogue/formation/update/${id}`, data: arg1});
  }
}

@Injectable()
export class ICommandeFormationWebServiceClient {

  constructor(protected httpClient: HttpClient) {
  }

  /**
   * update/{id}/addFormations
   * Response code 200 - Retourne la commande de formations modifiÃ©e
   * Response code 500 - Erreur interne
   * HTTP PUT /commande/update/{id}/addFormations
   * Java method: fr.cerba.digicerba.catalogueformation.webservices.commande.ICommandeFormationWebService.addFormations
   */
  addFormations(id: number, queryParams?: { formationIds?: number[]; }): RestResponse<CommandeFormationDto> {
    return this.httpClient.request({
      method: 'PUT',
      url: uriEncoding`commande/update/${id}/addFormations`,
      queryParams: queryParams
    });
  }

  /**
   * update/{id}/addParticipant
   * Response code 200 - Retourne la commande de formations modifiÃ©e
   * Response code 500 - Erreur interne
   * HTTP PUT /commande/update/{id}/addParticipant
   * Java method: fr.cerba.digicerba.catalogueformation.webservices.commande.ICommandeFormationWebService.addParticipantFormation
   */
  addParticipantFormation(id: number, arg1: SaveParticipantFormationDto): RestResponse<CommandeFormationDto> {
    return this.httpClient.request({method: 'PUT', url: uriEncoding`commande/update/${id}/addParticipant`, data: arg1});
  }

  /**
   * /cancelTransaction
   * Response code 200 - Annulation de la transaction rÃ©alisÃ©ee avec succÃ¨s
   * Response code 500 - Erreur interne lors de l'annulation du paiement
   * HTTP GET /commande/cancelTransaction
   * Java method: fr.cerba.digicerba.catalogueformation.webservices.commande.ICommandeFormationWebService.cancelTransaction
   */
  cancelTransaction(queryParams?: { Data?: string; Seal?: string; InterfaceVersion?: string; Encode?: string; locale?: string; }): RestResponse<void> {
    return this.httpClient.request({
      method: 'POST',
      url: uriEncoding`commande/cancelTransaction`,
      queryParams: queryParams
    });
  }

  /**
   * create
   * Response code 200 - Retourne la commande crÃ©Ã©e
   * Response code 500 - Erreur interne
   * HTTP POST /commande/create
   * Java method: fr.cerba.digicerba.catalogueformation.webservices.commande.ICommandeFormationWebService.createCommandeFormation
   */
  createCommandeFormation(queryParams?: { formationIds?: number[]; }): RestResponse<CommandeFormationDto> {
    return this.httpClient.request({method: 'POST', url: uriEncoding`commande/create`, queryParams: queryParams});
  }

  /**
   * createFull
   * Response code 200 - Retourne la commande crÃ©Ã©e
   * Response code 500 - Erreur interne
   * HTTP POST /commande/createFull
   * Java method: fr.cerba.digicerba.catalogueformation.webservices.commande.ICommandeFormationWebService.createFullCommandeFormation
   */
  createFullCommandeFormation(arg0: SaveCommandeFormationDto): RestResponse<CommandeFormationDto> {
    return this.httpClient.request({method: 'POST', url: uriEncoding`commande/createFull`, data: arg0});
  }

  /**
   * delete
   * Response code 200 - Supprime la commande de formations
   * HTTP DELETE /commande/delete/{id}
   * Java method: fr.cerba.digicerba.catalogueformation.webservices.commande.ICommandeFormationWebService.deleteCommandeFormation
   */
  deleteCommandeFormation(id: number, queryParams?: { notFinish?: boolean; }): RestResponse<boolean> {
    return this.httpClient.request({
      method: 'DELETE',
      url: uriEncoding`commande/delete/${id}`,
      queryParams: queryParams
    });
  }

  /**
   * update/{id}/participant/{idParticipant}/{idFormation}
   * Response code 200 - Retourne la commande de formations modifiÃ©e
   * Response code 500 - Erreur interne
   * HTTP DELETE /commande/update/{id}/participant/{idParticipant}/{idFormation}
   * Java method: fr.cerba.digicerba.catalogueformation.webservices.commande.ICommandeFormationWebService.deleteParticipantFormation
   */
  deleteParticipantFormation(id: number, idParticipant: number, idFormation: number): RestResponse<CommandeFormationDto> {
    return this.httpClient.request({
      method: 'DELETE',
      url: uriEncoding`commande/update/${id}/participant/${idParticipant}/${idFormation}`
    });
  }


  /**
   * {id}
   * Response code 200 -
   * Response code 500 - Erreur interne
   * HTTP GET /commande/{id}
   * Java method: fr.cerba.digicerba.catalogueformation.webservices.commande.ICommandeFormationWebService.findCommandeFormation
   */
  findCommandeFormation(id: number): RestResponse<CommandeFormationDto> {
    return this.httpClient.request({method: 'GET', url: uriEncoding`commande/${id}`});
  }

  /**
   * /startTransaction
   * Response code 200 - Transaction dÃ©marrÃ©e avec succÃ¨s
   * Response code 500 - Erreur interne Ã  la crÃ©ation de la transaction de paiement
   * HTTP POST /commande/startTransaction
   * Java method: fr.cerba.digicerba.catalogueformation.webservices.commande.ICommandeFormationWebService.startTransaction
   */
  startTransaction(arg0: number): RestResponse<Response> {
    return this.httpClient.request({method: 'POST', url: uriEncoding`commande/startTransaction`, data: arg0});
  }

  /**
   * update/{id}
   * Response code 200 - Retourne la commande de formations modifiÃ©e
   * HTTP PUT /commande/update/{id}
   * Java method: fr.cerba.digicerba.catalogueformation.webservices.commande.ICommandeFormationWebService.updateCommandeFormation
   */
  updateCommandeFormation(id: number, arg1: CommandeFormationDto): RestResponse<CommandeFormationDto> {
    return this.httpClient.request({method: 'PUT', url: uriEncoding`commande/update/${id}`, data: arg1});
  }

  /**
   * update/{id}/organismecommanditaire
   * Response code 200 - Retourne la commande de formations modifiÃ©e
   * Response code 500 - Erreur interne
   * HTTP PUT /commande/update/{id}/organismecommanditaire
   * Java method: fr.cerba.digicerba.catalogueformation.webservices.commande.ICommandeFormationWebService.updateOrganismeCommanditaire
   */
  updateOrganismeCommanditaire(id: number, arg1: OrganismeCommanditaireDto): RestResponse<CommandeFormationDto> {
    return this.httpClient.request({
      method: 'PUT',
      url: uriEncoding`commande/update/${id}/organismecommanditaire`,
      data: arg1
    });
  }

  /**
   * update/{id}/updateParticipant
   * Response code 200 - Retourne la commande de formations modifiÃ©e
   * Response code 500 - Erreur interne
   * HTTP PUT /commande/update/{id}/updateParticipant
   * Java method: fr.cerba.digicerba.catalogueformation.webservices.commande.ICommandeFormationWebService.updateParticipantFormation
   */
  updateParticipantFormation(id: number, arg1: SaveParticipantFormationDto): RestResponse<CommandeFormationDto> {
    return this.httpClient.request({
      method: 'PUT',
      url: uriEncoding`commande/update/${id}/updateParticipant`,
      data: arg1
    });
  }

  /**
   * validate/{id}
   * Response code 200 - Retourne la commande validÃ©e
   * HTTP PUT /commande/validate/{id}
   * Java method: fr.cerba.digicerba.catalogueformation.webservices.commande.ICommandeFormationWebService.validateCommandeFormation
   */
  validateCommandeFormation(id: number): RestResponse<CommandeFormationDto> {
    return this.httpClient.request({method: 'PUT', url: uriEncoding`commande/validate/${id}`});
  }
}

@Injectable()
export class IRessourceMultimediaWebServiceClient {

  constructor(protected httpClient: HttpClient) {
  }

  /**
   * /{id}
   * Response code 200 - Ressource multimedia rÃ©cupÃ©rÃ©e avec succÃ¨s
   * Response code 422 - Id null ou inconnu
   * Response code 500 - Erreur interne Ã  la rÃ©cupÃ©ration du contenu
   * HTTP GET /ressourcemultimedia/{id}
   * Java method: fr.cerba.digicerba.resourcemultimedia.webservices.IRessourceMultimediaWebService.getRessourceMultimedia
   */
  getRessourceMultimedia(id: number): RestResponse<Response> {
    return this.httpClient.request({method: 'GET', url: uriEncoding`ressourcemultimedia/${id}`});
  }
}

@Injectable()
export class ICorrespondantWebServiceClient {

  constructor(protected httpClient: HttpClient) {
  }

  /**
   * /
   * Response code 200 - Retourne le dÃ©tail des infos d'un correspondant
   * Response code 500 - Erreur interne Ã  la rÃ©cupÃ©ration des informations
   * HTTP GET /correspondant/{code}/details
   * Java method: fr.cerba.digicerba.shared.webservices.user.ICorrespondantWebService.getCorrespondantDetails
   */
  getCorrespondantDetails(code: string): RestResponse<CorrespondantDetailsDto> {
    return this.httpClient.request({method: 'GET', url: uriEncoding`correspondant/${code}/details`});
  }

  /**
   * /
   * Response code 200 - Retourne la liste des correspondant de l'utilisateur courant avec succÃ¨s
   * Response code 500 - Erreur interne Ã  la rÃ©cupÃ©ration des informations
   * HTTP GET /correspondant/all
   * Java method: fr.cerba.digicerba.shared.webservices.user.ICorrespondantWebService.getCorrespondants
   */
  getCorrespondants(): RestResponse<CorrespondantDto[]> {
    return this.httpClient.request({method: 'GET', url: uriEncoding`correspondant/all`});
  }

  /**
   * /tags
   * Response code 200 - Retourne les tags du correspondant courant
   * Response code 500 - Erreur interne Ã  la rÃ©cupÃ©ration des informations
   * HTTP GET /correspondant/tags
   * Java method: fr.cerba.digicerba.shared.webservices.user.ICorrespondantWebService.getTags
   */
  getTags(): RestResponse<string[]> {
    return this.httpClient.request({method: 'GET', url: uriEncoding`correspondant/tags`});
  }
}

@Injectable()
export class INotificationsCommonWebServiceClient {

  constructor(protected httpClient: HttpClient) {
  }

  /**
   * messages/count
   * HTTP GET /notification/messages/count
   * Java method: fr.cerba.digicerba.shared.webservices.user.INotificationsCommonWebService.countMessageNotifications
   */
  countMessageNotifications(): RestResponse<number> {
    return this.httpClient.request({method: 'GET', url: uriEncoding`notification/messages/count`});
  }
}

@Injectable()
export class ITechnicWebServiceClient {

  constructor(protected httpClient: HttpClient) {
  }

  /**
   * /correspondant/all
   * Response code 200 - Retourne les correspondants actifs
   * Response code 500 - Erreur interne Ã  la rÃ©cupÃ©ration des informations
   * HTTP GET /technic/correspondants/all
   * Java method: fr.cerba.digicerba.shared.webservices.user.ITechnicWebService.getCorrespondants
   */
  getCorrespondants(): RestResponse<CorrespondantDto[]> {
    return this.httpClient.request({method: 'GET', url: uriEncoding`technic/correspondants/all`});
  }

  /**
   * /tags/all
   * Response code 200 - Retourne les tags actifs
   * Response code 500 - Erreur interne Ã  la rÃ©cupÃ©ration des informations
   * HTTP GET /technic/tags/all
   * Java method: fr.cerba.digicerba.shared.webservices.user.ITechnicWebService.getTags
   */
  getTags(queryParams?: { locale?: string; }): RestResponse<TagLightDto[]> {
    return this.httpClient.request({method: 'GET', url: uriEncoding`technic/tags/all`, queryParams: queryParams});
  }
}

@Injectable()
export class IUserInformationsWebServiceClient {

  constructor(protected httpClient: HttpClient) {
  }

  /**
   * /check
   * Response code 200 - Retourne true si le module est accessible
   * Response code 401 - Le module n'est pas accessible
   * HTTP GET /check
   * Java method: fr.cerba.digicerba.shared.webservices.user.IUserInformationsWebService.checkAccess
   */
  checkAccess(): RestResponse<boolean> {
    return this.httpClient.request({method: 'GET', url: uriEncoding`check`});
  }

  /**
   * /
   * Response code 200 - Retourne les informations de l'utilisateur avec succÃ¨s
   * Response code 500 - Erreur interne Ã  la rÃ©cupÃ©ration des informations
   * HTTP GET /me
   * Java method: fr.cerba.digicerba.shared.webservices.user.IUserInformationsWebService.me
   */
  me(): RestResponse<UserInformations> {
    return this.httpClient.request({method: 'GET', url: uriEncoding`me`});
  }
}

export type RestResponse<R> = Observable<R>;

export type EtatCommandeEnum = 'BROUILLON' | 'CREEE' | 'EN_ATTENTE_PAIEMENT' | 'PAYEE';

export type ModePaiementEnum = 'CHEQUE' | 'EN_LIGNE';

export type CiviliteEnum = 'MONSIEUR' | 'MADAME';

export type UserRole =
  'COMPTE_LIE'
  | 'INVITE'
  | 'ANCIEN_COMPTE'
  | 'ADMINISTRATEUR'
  | 'RESPONSABLE'
  | 'MODULE'
  | 'PROSPECT';

export type Family = 'INFORMATIONAL' | 'SUCCESSFUL' | 'REDIRECTION' | 'CLIENT_ERROR' | 'SERVER_ERROR' | 'OTHER';

function uriEncoding(template: TemplateStringsArray, ...substitutions: any[]): string {
  let result = '/catalogue-formation/api/';
  for (let i = 0; i < substitutions.length; i++) {
    result += template[i];
    result += encodeURIComponent(substitutions[i]);
  }
  result += template[template.length - 1];
  return result;
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-catalogue-formation/digicerba-catalogue-formation-web/src/angular/cerba/src/app/common/resources/resources.ts